import kyy from './kyy.js'
export default {
	...kyy,
/*需求相关*/
	getUserList:{
		url:'/admin/User/getUserList'
	},
	getUserInfo:{
		url:'/admin/User/getUserInfo', isExport: true
	},
	setRecommendLevel:{
		url:'/admin/User/setRecommendLevel',isType:{suktip:true}
	},
	getContributorList:{
		url:'/admin/User/getContributorList'
	},

	getContributorInfo:{
		url:'/admin/User/getContributorInfo'
	},
	getRoleList:{
		url:'/admin/Role/getRoleList'
	},
	addRole:{
		url:'/admin/Role/add',isType:{suktip:true}
	},
	editRole:{
		url:'/admin/Role/edit',isType:{suktip:true}
	},
	deleteRole:{
		url:'/admin/Role/delete',isType:{suktip:true}
	},
	infoRole:{
		url:'/admin/Role/info'
	},
	getAdminUserInfo:{
		url:'/admin/AdminUser/getAdminUserInfo'
	},
	getAdminUserList:{
		url:'/admin/AdminUser/getAdminUserList'
	},
	getMenuList:{
		url:'/admin/menu/getMenuList'
	},
	reviewList1:{
		url:'/admin/Review/list?type=1'
	},
	reviewList2:{
		url:'/admin/Review/list?type=2'
	},
	reviewList3:{
		url:'/admin/Review/list?type=3'
	},
	reviewList4:{
		url:'/admin/Review/list?type=4'
	},
	reviewList5:{
		url:'/admin/Review/list'
	},
	access:{
		url:'/admin/Menu/access',isType:{isok:true}
	},

	setRole:{
		url:'/admin/AdminUser/setRole',isType:{suktip:true}
	},

	reviewInfo1:{
		url:'/admin/Review/info?type=1'
	},
	reviewInfo2:{
		url:'/admin/Review/info?type=2'
	},
	reviewInfo3:{
		url:'/admin/Review/info?type=3'
	},
	reviewInfo4:{
		url:'/admin/Review/info?type=4'
	},
	reviewInfo5:{
		url:'/admin/Review/info?type=5'
	},
	reviewInfo:{
		url:'/admin/Review/info'
	},

	reviewCheck1:{
		url:'/admin/Review/check?type=1',isType:{suktip:true}
	},
	reviewCheck2:{
		url:'/admin/Review/check?type=2',isType:{suktip:true}
	},
	reviewCheck3:{
		url:'/admin/Review/check?type=3',isType:{suktip:true}
	},
	reviewCheck4:{
		url:'/admin/Review/check?type=4',isType:{suktip:true}
	},
	reviewCheck:{
		url:'/admin/Review/check?type=5',isType:{suktip:true,isok:true}
	},
	reviewCheck8:{
		url:'/admin/Review/check?type=8',isType:{suktip:true,isok:true}
	},
	todoCount:{
		url:'/admin/Review/todoCount'
	},
	workList:{
		url:'/admin/work/list'
	},
	workInfo:{
		url:'/admin/Work/info'
	},
	setRecommendLevelwork:{
		url:'/admin/work/setRecommendLevel',isType:{suktip:true}
	},
	offShelve:{
		url:'/admin/work/offShelve',isType:{suktip:true}
	},
	getLevelCount:{
		url:'/admin/work/getLevelCount'
	},
	categoryList:{
		url:'/admin/category/list'
	},
	categoryAdd:{
		url:'/admin/category/add',isType:{suktip:true}
	},
	categoryEdit:{
		url:'/admin/category/edit',isType:{suktip:true}
	},
	workComment:{
		url:'/admin/work/comment'
	},
	deleteComment:{
		url:'/admin/work/deleteComment',isType:{suktip:true}
	},
	activitylist:{
		url:'/admin/activity/list'
	},
	activitydelete:{
		url:'/admin/activity/delete',isType:{suktip:true}
	},
	activityadd:{
		url:'/admin/activity/add',isType:{suktip:true,isok:true}
	},
	activityedit:{
		url:'/admin/activity/edit',isType:{suktip:true,isok:true}
	},
	insertFile:{
		url:'/File/File/insert'
	},
	reportlist:{
		url:'/admin/report/list'
	},
	Worklabel:{
		url:'/admin/Work/label'
	},
	settlement:{
        url:'/admin/Thirdapi/MoneyList'
	},
	activitywork:{
		url:'/admin/activity/work'
	},
	templateList1:{
		url:'/admin/template/list?type=1'
	},
	templateList2:{
		url:'/admin/template/list?type=2'
	},
	templateDelete1:{
		url:'/admin/template/delete?type=1',isType:{suktip:true}
	},
	templateDelete2:{
		url:'/admin/template/delete?type=2',isType:{suktip:true}
	},
	templateadd2:{
		url:'/admin/template/add?type=2',isType:{suktip:true}
	},
	templateadd1:{
		url:'/admin/template/add?type=1',isType:{suktip:true}
	},
	templateedit1:{
		url:'/admin/template/edit?type=1',isType:{suktip:true}
	},
	templateedit2:{
		url:'/admin/template/edit?type=2',isType:{suktip:true}
	},
	bannerlist:{
		url:'/admin/banner/list'
	},
	bannerdelete:{
		url:'/admin/banner/delete',isType:{suktip:true}
	},
	banneradd:{
		url:'/admin/banner/add',isType:{suktip:true}
	},
	banneredit:{
		url:'/admin/banner/edit',isType:{suktip:true}
	},
	bannerprogramadd:{
		url:'/admin/bannerprogram/add',isType:{suktip:true,isok:true}
	},
	bannerprogramlist:{
		url:'/admin/bannerprogram/list'
	},
	bannerprogramedit:{
		url:'/admin/bannerprogram/edit',isType:{suktip:true,isok:true}
	},
	bannerprogramdelete:{
		url:'/admin/bannerprogram/delete',isType:{suktip:true}
	},
	bannerprograminfo:{
		url:'/admin/bannerprogram/info'
	},
	hotwordlist:{
		url:'/admin/hotword/list'
	},
	hotworddelete:{
		url:'/admin/hotword/delete',isType:{suktip:true}
	},
	hotwordadd:{
		url:'/admin/hotword/add',isType:{suktip:true}
	},
	hotwordedit:{
		url:'/admin/hotword/edit',isType:{suktip:true}
	},

	recommendactivitylist:{
		url:'/admin/recommendactivity/list'
	},
	recommendactivityadd:{
		url:'/admin/recommendactivity/add',isType:{suktip:true,isok:true}
	},
	recommendactivityedit:{
		url:'/admin/recommendactivity/edit',isType:{suktip:true,isok:true}
	},
	documentadd:{
		url:'/admin/document/add',isType:{suktip:true}
	},

	documentlist:{
		url:'/admin/document/list'
	},
	documentdelete:{
		url:'/admin/document/delete',isType:{suktip:true}
	},
	orderlist:{
		url:'/admin/order/list'
	},
	orderinfo:{
		url:'/admin/order/info'
	},
	orderprofit:{
		url:'/admin/order/profit'
	},
	Workmaterial:{
		url:'/admin/Work/material'
	},
	reviewaddReason:{
		url:'/admin/review/addReason',isType:{suktip:true}
	},
	reviewreason:{
		url:'/admin/review/reason'
	},
	reviewupdateReason:{
		url:'/admin/review/updateReason',isType:{suktip:true}
	},
	feedbacklist:{
		url:'/admin/feedback/list'
	},
	feedbackclassify:{
		url:'/admin/feedback/classify'
	},
	reportclassify:{
		url:'/admin/report/classify'
	},
	noticelist:{
		url:'/admin/notice/list'
	},
	noticetemplate:{
		url:'/admin/notice/template'
	},
	usergetLevelCount:{
		url:'/admin/user/getLevelCount'
	},
	materialDetail:{
		url:'/admin/Work/materialDetail'
	},
	hire:{
		url:'/admin/work/hire',isType:{suktip:true}
	},
	documentedit:{
		url:'/admin/document/edit',isType:{suktip:true}
	},
	recommendactivityinfo:{
		url:'/admin/recommendactivity/info'
	},
	addClassify:{
		url:'/admin/feedback/addClassify',isType:{suktip:true}
	},
	updateClassify:{
		url:'/admin/feedback/updateClassify',isType:{suktip:true}
	},
	feedbackinfo:{
		url:'/admin/feedback/info'
	},
	reportinfo:{
		url:'/admin/report/info'
	},
	reportupdateClassify:{
		url:'/admin/report/updateClassify',isType:{suktip:true}
	},
	reportaddClassify:{
		url:'/admin/report/addClassify',isType:{suktip:true}
	},
	bannerprogramdefault:{
		url:'/admin/bannerprogram/default'
	},
	applyList:{
		url:'/admin/income/applyList'
	},
	// addnotice:{
	// 	url:'/admin/notice/add',isType:{suktip:true,isok:true}
	// },
	addnotice:{
		url:'/admin/notice/add',isType:{isok:true}
	},
	selfInfo:{
		url:'/admin/adminuser/selfInfo'
	},
	logout:{
		url:'/sso/login/logout',isType:{isok:true}
	},
	Workclassify:{
		url:'/admin/Work/classify',
	},
	activityinfo:{
		url:'/admin/activity/info',
	},
	noticedelete:{
		url:'/admin/notice/delete',isType:{isok:true}
	},

	taskList:{
		url:'/admin/Homerec/taskList'
	},
	Homerec_delete:{
		url:'/admin/Homerec/delete',isType:{suktip:true}
	},

	Homerec_add:{
		url:'/admin/Homerec/add',isType:{suktip:true}
	},

	Homerec_edit:{
		url:'/admin/Homerec/edit',isType:{suktip:true}
	},

	noticeedit:{
		url:'/admin/notice/edit',isType:{suktip:true,isok:true}
	},
	recommendactivitydelete:{
		url:'/admin/recommendactivity/delete',isType:{suktip:true}
	},
	noticesend:{
		url:'/admin/notice/send',isType:{suktip:true}
	},
	operateedit:{
		url:'/admin/operate/edit',isType:{suktip:true}
	},
	operatelist:{
		url:'/admin/operate/list'
	},
	operaterecord:{
		url:'/admin/operate/record'
	},
	demandlist:{
		url:'/admin/demand/list'
	},
	demandcheck:{
		url:'/admin/demand/check'
	},
	adminuseraccess:{
		url:'/admin/adminuser/access'
	},
	getRecommendCount:{
		url:'/admin/User/getRecommendCount'
	},
	getRecommendCountwork:{
		url:'/admin/work/getRecommendCount'
	},
	blacklist:{
		url:'/admin/user/blacklist'
	},
	forbiddenAccess:{
		url:'/admin/user/forbiddenAccess'
	},
	addBl:{
		url:'/admin/user/addBl',isType:{suktip:true,isok:true}
	},
	editBl:{
		url:'/admin/user/editBl',isType:{suktip:true,isok:true}
	},
	BlDetail:{
		url:'/admin/user/BlDetail'
	},
	projectclassifylist:{
		url:'/admin/projectclassify/list'
	},
	pr_question:{
		url:'/admin/project/question',
	},
	projectclassifyadd:{
		url:'/admin/projectclassify/add',isType:{suktip:true,isok:true}
	},
	projectclassifyupdate:{
		url:'/admin/projectclassify/update',isType:{suktip:true,isok:true}
	},
	projectlist:{
		url:'/admin/project/list'
	},
	projectgetid:{
		url:'/admin/project/getid'
	},
	zipfile:{
        url:'/admin/Zipfile/zipfile'
	},
	projecttemplatelist:{
		url:'/admin/projecttemplate/list'
	},
	projecttemplateadd:{
		url:'/admin/projecttemplate/add',isType:{suktip:true,isok:true}
	},
	projecttemplatedetail:{
		url:'/admin/projecttemplate/detail'
	},
	projecttemplatedel:{
		url:'/admin/projecttemplate/del',isType:{suktip:true,isok:true}
	},
	projecttemplateupdate:{
		url:'/admin/projecttemplate/update',isType:{suktip:true,isok:true}
	},
	projectadd:{
		url:'/admin/project/add',isType:{suktip:true,isok:true}
	},
	projectdetail:{
		url:'/admin/project/detail'
	},
	selectUser:{
		url:'/admin/project/selectUser',isType:{isok:true}
	},
	projectupdate:{
		url:'/admin/project/update',isType:{suktip:true,isok:true}
	},
	projectdel:{
		url:'/admin/project/del',isType:{suktip:true,isok:true}
	},
	signupList:{
		url:'/admin/project/signupList'
	},
	fileRecord:{
		url:'/admin/project/fileRecord'
	},
	terminate:{
		url:'/admin/project/terminate',isType:{suktip:true,isok:true}
	},
	contractList:{
		url: '/admin/project/ContractList',isType:{suktip:false,isok:true}
	},
	addContract:{
		url:'/admin/project/addContract',isType:{suktip:true,isok:true}
	},
	delContract:{
		url:'/admin/project/delContract',isType:{suktip:true,isok:true}
	},
	bindContract:{
		url:'/admin/project/bindContract',isType:{suktip:true,isok:true}
	},
	profitconfiginfo:{
		url:'/admin/profitconfig/info'
	},
	profitconfigsave:{
		url:'/admin/profitconfig/save',isType:{suktip:true}
	},
	RecommendProjectlist:{
		url:'/admin/RecommendProject/list'
	},
	RecommendProjectadd:{
		url:'/admin/RecommendProject/add',isType:{suktip:true,isok:true}
	},
	RecommendProjectedit:{
		url:'/admin/RecommendProject/edit',isType:{suktip:true,isok:true}
	},
	RecommendProjectdelete:{
		url:'/admin/RecommendProject/delete',isType:{suktip:true,isok:true}
	},
	getSkillInfo:{
		url:'/Admin/User/getUserSkill'
	},
	worksubjectlist:{
		url:'/admin/worksubject/list'
	},
	worksinfos:{
		url:'/admin/work/infos'
	},
	worksubjectadd:{
		url:'/admin/worksubject/add',isType:{suktip:true,isok:true}
	},
	worksubjectdel:{
		url:'/admin/worksubject/del',isType:{suktip:true,isok:true}
	},
	worksubjectupdate:{
		url:'/admin/worksubject/update',isType:{suktip:true,isok:true}
	},
	projectshelve:{
		url:'/admin/project/shelve',isType:{suktip:true,isok:true}
	},
	probjLongpcList:{
		url:'/admin/Project/pcList'
	},
	subprojectsList:{
		url:'/admin/project/subprojectsList'
	},
	subprogetCount:{
		url:'/admin/project/getCount'
	},


	Noticeemaillist:{
		url:'/admin/Noticeemail/list'
	},
	Noticeemaildetail:{
		url:'/admin/Noticeemail/detail'
	},


	Noticeemailadd:{
		url:'/admin/Noticeemail/add',isType:{suktip:true,isok:true}
	},
	Noticeemaildelete:{
		url:'/admin/Noticeemail/delete',isType:{suktip:true,isok:true}
	},

	Noticeemailedit:{
		url:'/admin/Noticeemail/edit',isType:{suktip:true,isok:true}
	},

	getbusiness:{
		url:'/admin/Project/business'
	},
	// 获取业务所有类型
	getBusinessList: {
		url: '/admin/Project/business',
		
		
	},
	// 获取锁屏配置
	setLockScreenConfig:{
		url:'/admin/Operate/lockScreenConfig',
		method:'post',
		
	},
	// 获取锁屏工具下载地址
	getDownloadUrl:{
		url:'/admin/Operate/getDownloadUrl',
		method:'post',
		
	},
	// 设置个人中心
	setHomePageConfig: {
		url: '/admin/user/HomePageConfig',
		
		
	},
	// 获取个人中心设置
	getHomePageConfig: {
		url: '/admin/user/HomePageDetail',
		
		
	},
	// 获取奖品列表
	getPrizeList: {
		url: '/admin/Prize/list',
		
		
		varConversion: true,
		isExport: true
	},
	// 添加奖品
	prizeAdd: {
		url: '/admin/Prize/add',
		
		
		varConversion: true
	},
	// 奖品详情
	getPrizeDetail: {
		url: '/admin/Prize/detail',
		
		
		varConversion: true
	},
	// 奖品编辑
	prizeEdit: {
		url: '/admin/Prize/edit',
		varConversion: true
	},
	// 上下架奖品
	prizeShelve: {
		url: '/admin/Prize/shelve',
		varConversion: true
	},
	// 兑换记录列表
	getExchangeList: {
		url: '/admin/prize/exchangeList',
		varConversion: true,
		isExport: true
	},
	// 兑换详情
	getExchangeDetail: {
		url: '/admin/prize/exchangeDetail',
		varConversion: true
	},
	// 兑换记录设为发货和取消发货
	setShipping: {
		url: '/admin/Prize/setShipping',
		varConversion: true
	},
	// 好友行为奖励设置
	friendsBehaviorReward: {
		url: '/admin/Operate/friendsBehaviorReward',
		varConversion: true
	},
	// 用户单独行为奖励设置
	vipBehaviorReward: {
		url: '/admin/operate/vipBehaviorReward',
		varConversion: true
	},
	// 用户拉新行为记录表
	friendBehaviorlist: {
		url: '/admin/user/friendBehaviorlist',
		varConversion: true,
		isExport: true
	},
	// 默认好友行为奖励设置详情
	friendsBehaviorRewardDetail: {
		url: '/admin/operate/friendsBehaviorRewardDetail',
		varConversion: true,
		isExport: true
	},
	// 友情l链接配置
	getLinkConfig: {
		url: '/admin/operate/getLinkDetail',	
	},
	// 友情l链接详情
	saveLinkConfig: {
		url: '/admin/operate/linkConfig',
		
		
	},
	// 活动奖品列表
	getActivityPrizeList: {
		url: '/admin/Activity/programList',
		varConversion: true
	},
	// 奖品库
	getActivityPrizeLibrary: {
		url: '/admin/Activity/prizeList',
		varConversion: true
	},
	// 抽奖方案详情
	programDetail: {
		url: '/admin/Activity/programDetail',
		
		
		varConversion: true
	},
	// 抽奖方案编辑
	editProgram: {
		url: '/admin/Activity/editProgram',
		
		
		varConversion: true
	},
	// 添加奖品
	activeAddPrize: {
		url: '/admin/Activity/addPrize',
		
		
		varConversion: true
	},
	// 编辑奖品
	activeEditPrize: {
		url: '/admin/Activity/editPrize',
		
		
		varConversion: true
	},
	// 抽奖方案删除
	activeDelProgram: {
		url: '/admin/Activity/delProgram',
		
		
		varConversion: true,
		isExport: true
	},
	// 抽奖方案新增
	activeAddProgram: {
		url: '/admin/Activity/addProgram',
		
		
		varConversion: true
	},
	// 抽奖类型
	activeDrawTypes: {
		url: '/admin/Activity/drawTypes',
		
		
		varConversion: true
	},
	// 删除奖品
	activityDelPrize: {
		url: '/admin/Activity/delPrize',
		
		
		varConversion: true
	},
	// 中奖纪录表
	activityWinningRecord: {
		url: '/admin/Activity/winningRecord',
		
		
		varConversion: true,
		isExport: true
	},
	// 中奖详情
	activityWinningDetail: {
		url: '/admin/Activity/winningDetail',
		
		
		varConversion: true
	},
	// 发货和取消发货
	activitySetShipping: {
		url: '/admin/Activity/setShipping',
		
		
		varConversion: true
	},
	// 活动上下架
	activitShelve: {
		url: 'admin/Activity/shelve',
		
		
		varConversion: true
	},
	// 摄影作品列表
	photoworkList: {
		url: '/admin/photowork/list',
		
		
		varConversion: true,
		isExport: true
	},
	// 摄影作品详情
	getPhotoworkDetail: {
		url: 'admin/photowork/detail',
		varConversion: true
	},
	// 绑定合同
	photoworkAddContract: {
		url: 'admin/Photowork/addContract',
		varConversion: true
	},
	// 查询已绑定的合同列表
	getPhotoworkContractList: {
		url: 'admin/Photowork/ContractList',
		varConversion: true
    },
    // 查询已绑定的合同列表
	getContributionworkContractList: {
		url: 'admin/Contributionwork/ContractList',
		varConversion: true
    },
	// 删除摄影合同
	delPhotoworkContract: {
		url: 'admin/Photowork/delContract',
		varConversion: true
	},
	// 获取素材风格
	getMidTypes: {
		url: 'admin/Photowork/getMidTypes',
		varConversion: true
	},
	// 审核台功能标签列表
	getTagFuncId: {
		url: 'admin/Photowork/getTagFuncId',
		varConversion: true
	},
	// 审核台查询标签
	getTagSearchId: {
		url: 'admin/photowork/getTagSearchId',
		varConversion: true
	},
	// 获取素材格式
	getMidFormats: {
		url: 'admin/Photowork/getMidFormats',
		varConversion: true
	},
	// 摄影审核
	photoworkReviewcheck: {
		url: 'admin/Review/check',
		varConversion: true
	},
	// 摄影审核详情
	photoworkReviewInfo:{
		url: 'admin/Review/info?type=8',
		varConversion: true
	},
	// 摄影审核列表
	photoworkReviewList:{
		url: '/admin/Review/list',
		varConversion: true
	},
	// 临时分配权限-获取业务类型
	getPermissionBusiness:{
		url: '/admin/Operatepermissionassign/getConf',
		varConversion: true
	},
	// 临时分配权限-获取用户
	getPermissionUserList:{
		url: '/admin/AdminUser/getAdminUserList',
		varConversion: true
	},
	// 临时分配权限-新增
	permissionAdd:{
		url: '/admin/Operatepermissionassign/add',
		varConversion: true
	},
	// 临时分配权限-列表
	permissionList:{
		url: '/admin/Operatepermissionassign/list',
		varConversion: true
	},
	// 临时分配权限-删除
	permissionDelete:{
		url: '/admin/Operatepermissionassign/delete',
		varConversion: true
	},
	// 临时分配权限-更新
	permissionUpdate:{
		url: '/admin/Operatepermissionassign/update',
		varConversion: true
	},
	// 新增标签
	addTagSearchId:{
		url: '/admin/photowork/addTagSearchId',
		varConversion: true
	},
	// 报名列表
   getSignInfoList:{
		url: '/admin/activity/signInfoList',
		varConversion: true
	},
	// 业务类型
	getProgressBusinesslist:{
		url: '/admin/Business/list',
		varConversion: true
	},
	// 摄影投稿
	getProgressPhotoWorklist:{
		url: '/admin/Business/photoWork',
		varConversion: true
	},
	// 新增业务类型
	businessAdd:{
		url: '/admin/Business/add',
		varConversion: true
	},
	// 删除业务类型
	businessDel:{
		url: '/admin/Business/del',
		varConversion: true
	},
	// 获取业务类型详情
	getBusinessDetail:{
		url: '/admin/Business/detail',
		varConversion: true
	},
	// 获取业务类型编辑
	businessEdit:{
		url: '/admin/Business/edit',
		varConversion: true
	},
	// ip列表
	photoworkIpList:{
		url: '/admin/photowork/ipList',
		varConversion: true
	},
	// 取消素材类型数据检查
	hasUseMidType:{
		url: '/admin/Business/hasUseMidType',
		varConversion: true
	},
	// 投稿作品列表
	getContributionworkList:{
		url: '/admin/Contributionwork/list',
		varConversion: true,
		isExport: true
    },
    // 获取作品业务类型定价配置
	getContributionWorkConfig: {
		url: '/admin/Business/contributionWork',
		varConversion: true
    },
    // 投稿作品详情
	getContributionDetail: {
		url: '/admin/Contributionwork/detail',
		varConversion: true
    },
    // 投稿作品合同绑定
	contributionworkAddContract: {
		url: '/admin/Contributionwork/addContract',
		varConversion: true
    },
    // 投稿作品合同删除绑定关系
	contributionworkDelContract: {
		url: '/admin/Contributionwork/delContract',
		varConversion: true
    },

	//锁屏工具模板&版本控制配置
	lockScreenList: {
		url: '/admin/Lockscreen/list',
		varConversion: true
	},

	//模板上下架
	lockScreenShelve: {
		url: '/admin/Lockscreen/shelve',
		varConversion: true
	},

	//模板分类列表
	lockScreenClassify: {
		url: '/admin/Lockscreen/classify',
		varConversion: true
	},

	//模板新增
	lockScreenAdd: {
		url: '/admin/Lockscreen/add',
		varConversion: true
	},

	//模板编辑
	lockScreenEditor: {
		url: '/admin/Lockscreen/edit'
	},

	//模板详情
	lockScreenDetail: {
		url: '/admin/Lockscreen/detail',
	},


    // 投稿储备库
	getWorkList: {
		url: '/admin/work/list',
		varConversion: true
    },
    // 获取作品分类
	getWorkClassify: {
		url: '/admin/Work/classify',
		varConversion: true
    },
    // 设置作品等级
	setWorkRecommendLevel: {
		url: '/admin/work/setRecommendLevel',
		varConversion: true
    },
    // 发起邀稿
	addInvitationProject: {
		// url: '/admin/Work/addInvitationProject',
		// url: '/admin/Work/addInvitationChannel',
		url: '/admin/Channel/addInvitation',
		varConversion: true
  },
    // 获取项目类型
	getProjectclassifyList: {
		url: '/admin/projectclassify/list',
		varConversion: true
    },
    // 获取业务类型
	getProjectBusiness: {
		url: '/admin/Project/business',
		varConversion: true
    },
    // 获取项目模板
	getProjecttemplate: {
		url: '/admin/projecttemplate/list',
		varConversion: true
    },
    // 获取邀约详情
	getInvitationDetail: {
		// url: '/admin/Work/invitationDetail',
		url:'admin/Channel/detail',
		varConversion: true
  },
    // 用户推荐等级
  setUserRecommendLevel: {
		url: '/admin/User/setRecommendLevel',
		varConversion: true
  },
	//公共账号列表
	pubAccountList: {
		url: '/admin/User/pubAccountList',
		varConversion: true
	},

	//积分任务列表
	pointsystemList: {
		url: "/admin/Pointsystem/list",
		varConversion: true
	},

	//新增任务
	pointsystemAdd: {
		url: "/admin/Pointsystem/add",
		varConversion: true
	},

	//编辑积分任务
	pointsystemEdit: {
		url: "/admin/Pointsystem/edit",
		varConversion: true
	},

	//积分任务详情
	pointsystemDetail: {
		url: "/admin/Pointsystem/detail",
		varConversion: true
	},

	//积分上下架
	pointsystemShelve: {
		url: "/admin/Pointsystem/shelve",
		varConversion: true
	},

	//积分任务完成记录
	pointsystemCompletionList: {
		url: "/admin/Pointsystem/completionList",
		varConversion: true
	},

	//积分发放
	pointsystemCoinGrant: {
		url: "/admin/Pointsystem/grantCoin",
		varConversion: true
	},

	//发放积分详情
	pointsystemGrandDetail: {
		url: "/admin/Pointsystem/grantDetail",
		varConversion: true
	},

	//发放积分编辑
	pointsystemGrantEdit: {
		url: "/admin/Pointsystem/grantEdit",
		varConversion: true
	},

	//删除积分发放记录
	pointsystemGrantDel: {
		url: "/admin/Pointsystem/grantDel",
		varConversion: true
	},

	//积分任务类型
	pointsystemTaskType: {
		url: "/admin/Pointsystem/taskType",
		varConversion: true
	},

	//积分发放列表
	poinsystemGrantList: {
		url: "/admin/Pointsystem/grantList",
		varConversion: true
	},
	// 工程列表模板
	lockProjectTemplates: {
		url: '/Admin/Lockscreen/projectTemplates',
		varConversion: true
	},
	// 新增工程模板
	addProjectTmplate: {
		url: '/admin/Lockscreen/addProjectTemplate',
		varConversion: true
	},
	// 编辑工程模板 
	editProjectTmplate: {
		url: '/admin/Lockscreen/editProjectTemplate',
	},
	// 工程模板详情
  detailProjectTmplate: {
		url: '/admin/Lockscreen/projectTemplateDetail',
	},
	// 工程模板上下架
  shelveProjectTmplate: {
		url: '/admin/Lockscreen/shelveProjectTemplate',
		varConversion: true
	},
	// 工程模板分类
	tmpTypeList: {
		url: '/admin/Lockscreen/projectTemplateTypes',
		varConversion: true
	},
	/*** 妙探文创接口 ***/
  // 用户信息表
	userList: {
		url: '/admin/Quicker/userList',	
	},
	getBannerList: {
		url: '/admin/Quicker/bannerList',	
	},
  /*** 空中逛展 ***/
	// 展示位列表
	getExhibitionList: {
		url: '/admin/Quicker/exhibitionList',			
	},
	// 新建展示位
  addExhibition: {
		url: '/admin/Quicker/addExhibition',
	},
	// 编辑展示位
	editExhibition: {
		url: '/admin/Quicker/editExhibition',	
	},
  // 删除展示位
	delExhibition: {
		url: '/admin/Quicker/delExhibition',
	},
	// 展示位详情
	exhibitionDetail: {
		url: '/admin/Quicker/exhibitionDetail',
	},
	// 上下架展示位
	shelveExhibition: {
		url: '/admin/Quicker/shelveExhibition',
	},
	// 新建banner
	addBanner: {
		url: '/admin/Quicker/addBanner',	
	},
	// 编辑banner
	editBanner: {
		url: '/admin/Quicker/editBanner',	
	},
  // 删除banner
	delBanner: {
		url: '/admin/Quicker/delBanner',
	},
	// 上下架banner
	shelveBanner: {
		url: '/admin/Quicker/shelveBanner',	
	},
  // banner 详情
	bannerDetail: {
		url: '/admin/Quicker/bannerDetail',
	},
	// 专题列表
	subjectList: {
		url: '/admin/Quicker/subjectList',
	},
	// 文章列表
	getArticleList: {
		url: '/admin/Quicker/articleList',
	},
	// 新建文章
	addArticle: {
		url: '/admin/Quicker/addArticle',
		
		
	},
	// 文章分类
	getArticleClassify: {
		url: '/admin/Quicker/articleClassify',
		
		
	},
	// ip列表
	getIpList: {
		url: '/admin/Quicker/ipList',
		
		
	},
	// 查看文章详情
	detailArticle: {
		url: '/admin/Quicker/detailArticle',
		
		
	},
	// 编辑文章
	editArticle: {
		url: '/admin/Quicker/editArticle',
		
		
	},
	// 删除文章
	delArticle: {
		url: '/admin/Quicker/delArticle',
		
		
	},
	// 文章上下架
	shelveArticle: {
		url: '/admin/Quicker/shelveArticle',
		
		baseURL :0
	},
	// 发现艺术-展示
	getArtList: {
		url: '/admin/Quicker/artList',
		
		
	},
	// 发现艺术-保存
	getDiscoverArt: {
		url: '/admin/Quicker/discoverArt',			
	},
	// 新增专题列表
	addSubject: {
		url: '/admin/Quicker/addSubject',		
	},
	// 专题详情
	subjectDetail: {
		url: '/admin/Quicker/subjectDetail',				
	},
	// 编辑专题
	editSubject: {
		url: '/admin/Quicker/editSubject',				
	},
	// 删除专题
	delSubject: {
		url: '/admin/Quicker/delSubject',				
	},
	// 内容管理
	getContentList: {
		url: '/admin/Quicker/contentList',		
	},
	// 新建内容
	addContent: {
		url: '/admin/Quicker/addContent',
	},
	// 编辑内容
	editContent: {
		url: '/admin/Quicker/editContent',
	},
	// 内容详情
	contentDetail: {
		url: '/admin/Quicker/contentDetail',	
	},
	// 删除内容
	delContent: {
		url: '/admin/Quicker/delContent',
	},
	/*** 玩趣古今 ***/
	// 展示位列表
	pastExhibitionList: {
		url: '/admin/Quicker/pastExhibitionList',
	},
	// 新建展示位
	addPastExhibition: {
		url: '/Admin/Quicker/addPastExhibition',				
	},
	// 编辑展示位
	editPastExhibition: {
		url: '/admin/Quicker/editPastExhibition',				
	},
	// 展示位详情
	detailPastExhibition: {
		url: '/Admin/Quicker/detailPastExhibition',				
	},
	// 删除展示位
	delPastExhibition: {
		url: '/admin/Quicker/delPastExhibition',				
	},
	// 上下架展示位
	shelvePastExhibition: {
		url: '/Admin/Quicker/shelvePastExhibition',				
	},
	// 渠道列表
	channels: {
		url: '/admin/Quicker/channels',				
	},
	/*** 趣读快应用 ***/
	// 趣读-展示位列表
	displayList: {
		url: '/admin/Quicker/displayList',		
	},
	// 趣读-新建展示位
	addDisplay: {
		url: '/Admin/Quicker/addDisplay',				
	},
	// 趣读-编辑展示位
	editDisplay: {
		url: '/admin/Quicker/editDisplay',				
	},
	// 趣读=展示位详情
	detailDisplay: {		
		url: '/Admin/Quicker/detailDisplay',				
	},
	// 趣读-删除展示位
	delDisplay: {
		url: '/admin/Quicker/delDisplay',				
	},
	// 趣读-上下架展示位
	shelveDisplay: {
		url: '/Admin/Quicker/shelveDisplay',
	},

	quickerChannels: {
		url: '/admin/Quicker/channels',		
	},
	quickerAddcChannel: {
		url: '/admin/Quicker/addChannel',		
	},
	quickerEditChannel: {
		url: '/admin/Quicker/editChannel',		
	},
	quickerChannelPageList: {
		url: '/admin/Quicker/channelPageList',		
	},
	quickerAddChannelPage: {
		url: '/admin/Quicker/addChannelPage',		
	},
	quickerEditChannelPage: {
		url: '/admin/Quicker/editChannelPage',		
	},
	quickerDelChannelPage: {
		url: '/admin/Quicker/delChannelPage',		
	},
	
	quickerOffContent: {
		url: '/admin/Quicker/OffContent',		
	},
	
	quickerSetArticleChannel: {
		url: '/admin/Quicker/setArticleChannel',		
	},
	// 类型列表
	get_type_list: {
		url: '/admin/Oppowallpaper/typeList',
		method: 'post',
		baseURL: 0
	},
	// 类型新增
	add_type: {
		url: '/admin/Oppowallpaper/addType',
		method: 'post',
		baseURL: 0
	},
	//编辑资源
	edit_type: {
		url: '/admin/Oppowallpaper/editType',
		method: 'post',
		baseURL: 0
	},
	// 类型删除
	del_type: {
		url: '/admin/Oppowallpaper/delType',
		method: 'post',
		baseURL: 0
	},
	// 获取资源列表
	get_oppowallpaper_list: {
		url: '/admin/Oppowallpaper/list',
		method: 'post',
		baseURL: 0
	},
	// 资源新增
	add_oppowallpaper: {
		url: '/admin/Oppowallpaper/add',
		method: 'post',
		baseURL: 0
	},
	// 资源编辑
	edit_oppowallpaper: {
		url: '/admin/Oppowallpaper/edit',
		method: 'post',
		baseURL: 0
	},
	// 资源删除
	del_oppowallpaper: {
		url: '/admin/Oppowallpaper/del',
		method: 'post',
		baseURL: 0
	},
	// 催审配置
	operate_boostCheckConfig: {
		url: '/Admin/Operate/boostCheckConfig',
		method: 'post',
		baseURL: 0
	},
	// 催审配置详情
	operate_boostCheckDetail: {
		url: '/admin/Operate/boostCheckDetail',
		method: 'post',
		baseURL: 0
	},
	// 项目审核列表
	review_list: {
		url: '/admin/review/list',
		method: 'post',
		baseURL: 0
	},
	// 交稿文件记录
	channel_fileRecords: {
		url: '/admin/Channel/fileRecords',
		method: 'post',
		baseURL: 0
	},
	// 邀稿详情
	channel_detail: {
		url: '/Admin/Channel/detail',
		method: 'post',
		baseURL: 0
	},
	// 审核台审核详情(渠道分发)
	review_info: {
		url: '/Admin/Review/info',
		method: 'post',
		baseURL: 0
	},
	// 催审/上线记录
	operate_boostRecords: {
		url: '/Admin/Operate/boostRecords',
		method: 'post',
		baseURL: 0
	},
	// 专题-预设标签
	subjectTags: {
		url: '/admin/Quicker/subjectTags',
		method: 'post',
		baseURL: 0
	},
	// 资源列表
	oppowallpaper_list: {
		url: '/admin/Oppowallpaper/list',
		method: 'post',
		baseURL: 0
	},
	// 展示对象新增
	oppowallpaper_addChannel: {
		url: '/admin/Oppowallpaper/addChannel',
		method: 'post',
		baseURL: 0
	},
	// 展示对象列表
	oppowallpaper_channelList: {
		url: '/admin/Oppowallpaper/channelList',
		method: 'post',
		baseURL: 0
	},
	// 展示对象详情
	admin_Oppowallpaper_detailChannel: {
		url: '/admin/Oppowallpaper/detailChannel',
		method: 'post',
		baseURL: 0
	},
	// 展示对象编辑
	admin_Oppowallpaper_editChannel: {
		url: '/admin/Oppowallpaper/editChannel',
		method: 'post',
		baseURL: 0
	},
	// 展示对象删除
	oppowallpaper_delChannel: {
		url: '/admin/Oppowallpaper/delChannel',
		method: 'post',
		baseURL: 0
	},
	// 资源列表
	// oppowallpaper_list: {
	// 	url: '/admin/Oppowallpaper/list',
	// 	method: 'post',
	// 	baseURL: 0
	// },
	// 资源新增
	oppowallpaper_add: {
		url: '/admin/Oppowallpaper/add',
		method: 'post',
		baseURL: 0
	},
	// 资源删除
	oppowallpaper_del: {
		url: '/admin/Oppowallpaper/del',
		method: 'post',
		baseURL: 0
	},
	// 资源详情
	oppowallpaper_detail: {
		url: '/admin/Oppowallpaper/detail',
		method: 'post',
		baseURL: 0
	},
	// 资源编辑
	oppowallpaper_edit: {
		url: '/admin/Oppowallpaper/edit',
		method: 'post',
		baseURL: 0
	},
	// 【锁屏工具】协议列表
	lockscreen_protocolList: {
		url: '/admin/Lockscreen/protocolList',
		method: 'post',
		baseURL: 0
	},
	// 【锁屏工具】协议新增
	lockscreen_addProtoc: {
		url: '/admin/Lockscreen/addProtocol',
		method: 'post',
		baseURL: 0
	},
	// 【锁屏工具】协议详情
	lockscreen_protocolDetail: {
		url: '/admin/Lockscreen/protocolDetail',
		method: 'post',
		baseURL: 0
	},
	// 【锁屏工具】协议编辑
	lockscreen_editProtocol: {
		url: '/admin/Lockscreen/editProtocol',
		method: 'post',
		baseURL: 0
	},
	// 【锁屏工具】协议删除
	lockscreen_delProtocol: {
		url: '/admin/Lockscreen/delProtocol',
		method: 'post',
		baseURL: 0
	},
	// 【锁屏工具】协议上下架
	lockscreen_shelveProtocol: {
		url: '/admin/Lockscreen/shelveProtocol',
		method: 'post',
		baseURL: 0
	},
	// 【锁屏工具】白名单列表
	lockscreen_whiteIpList: {
		url: '/admin/Lockscreen/whiteIpList',
		method: 'post',
		baseURL: 0
	},
	//【锁屏工具】白名单上下架
	lockscreen_shelveWhiteIp: {
		url: '/admin/Lockscreen/shelveWhiteIp',
		method: 'post',
		baseURL: 0
	},
	//【锁屏工具】白名单删除
	lockscreen_delWhiteIp: {
		url: '/admin/Lockscreen/delWhiteIp',
		method: 'post',
		baseURL: 0
	},
	//【锁屏工具】新增白名单
	lockscreen_addWhiteIp: {
		url: '/admin/Lockscreen/addWhiteIp',
		method: 'post',
		baseURL: 0
	},
	//【锁屏工具】白名单详情
	lockscreen_whiteIpDetail: {
		url: '/admin/Lockscreen/whiteIpDetail',
		method: 'post',
		baseURL: 0
	},
	//【锁屏工具】编辑白名单
	lockscreen_editWhiteIp: {
		url: '/admin/Lockscreen/editWhiteIp',
		method: 'post',
		baseURL: 0
	},
	//【锁屏工具】用户列表
	lockscreen_userList: {
		url: '/admin/Lockscreen/userList',
		method: 'post',
		baseURL: 0
	},

	//用户搜索词列表
	hotWordList: {
		url: '/admin/Log/hotWordList',
		method: 'post',
	},
	
	//后台管理员日志列表
	adminBehaviorList: {
		url: '/admin/Log/adminBehaviorList',
		method: 'post',
	},
	//用户浏览记录表
	userBehaviorList: {
		url: '/admin/Log/userBehaviorList',
		method: 'post',
	},

	//分类树
	Lockscreen: {
		url: '/Admin/Lockscreen/commonType',
		method: 'post',
	},

	Lockdel: {
		url: '/Admin/Lockscreen/del',
		method: 'post',
	},

	delProjectTemplate: {
		url: '/admin/Lockscreen/delProjectTemplate',
		method: 'post',
	},

	thirdapi_channelList: {
		url: '/Thirdapi/channelLis',
		method: 'get',
	},
	// 【锁屏工具】分类管理列表
	lockscreen_catList: {
		url: '/admin/Lockscreen/catList',
		method: 'post',
		baseURL: 0
	},
	// 【锁屏工具】分类管理新增
	lockscreen_addCat: {
		url: '/admin/Lockscreen/addCat',
		method: 'post',
		baseURL: 0
	},
	// 【锁屏工具】分类管理编辑
	lockscreen_editCat: {
		url: '/admin/Lockscreen/editCat',
		method: 'post',
		baseURL: 0
	},
	// 【锁屏工具】分类管理删除
	lockscreen_delCat: {
		url: '/admin/Lockscreen/delCat',
		method: 'post',
		baseURL: 0
	},
	// 【锁屏工具】分类管理上下架
	lockscreen_shelveCat: {
		url: '/admin/Lockscreen/shelveCat',
		method: 'post',
		baseURL: 0
	},
	//【锁屏工具】分类管理详情
	lockscreen_detailCat: {
		url: '/admin/Lockscreen/detailCat',
		method: 'post',
		baseURL: 0
	},
	//入库作品点击上线
	channel_onlineWork: {
		url: '/Admin/channel/onlineWork',
		method: 'post',
		baseURL: 0
	},

	fastappfeedbackstat: {
		url: '/admin/fastappfeedback/stat',
		method: 'post',
	},
	
	//获取壁纸列表
	wallpaper_list: {
		url: '/admin/wallpaper/list',
		method: 'post',
		baseURL: 0
	},

	//获取壁纸分类信息列表
	wallpaper_categorylist: {
		url: '/admin/wallpaper/categorylist',
		method: 'post',
		baseURL: 0
	},

	//审核壁纸
	wallpaper_check: {
		url: '/admin/wallpaper/check',
		method: 'post',
		baseURL: 0
	},

	//修改壁纸
	wallpaper_edit: {
		url: '/admin/wallpaper/edit',
		method: 'post',
		baseURL: 0
	},

	//删除壁纸
	wallpaper_del: {
		url: 'admin/wallpaper/del',
		method: 'post',
		baseURL: 0
	},

	//获取待管理员审核内容列表信息
	green_contentCheckList: {
		url: 'admin/Green/contentCheckList',
		method: 'post',
		baseURL: 0
	},
	
	//获取审核内容列表信息
	green_contentList: {
		url: 'admin/Green/contentList',
		method: 'post',
		baseURL: 0
	},

	//获取ai审核详情列表信息
	green_detailList: {
		url: 'admin/Green/detailList',
		method: 'post',
		baseURL: 0
	},

	//管理员审核
	green_check: {
		url: 'admin/Green/check',
		method: 'post',
		baseURL: 0
	},

	//下线
	channel_offlineWork: {
		url: 'Admin/channel/offlineWork',
		method: 'post',
		baseURL: 0
	},
	// 作品发布审核机制-审核方式查询
	checkInfo: {
		url: '/admin/config/info',
		method: 'post',
		baseURL: 0
	},
  // 作品发布审核机制-保存
	checkEdit: {
		url: '/admin/config/edit',
		method: 'post',
		baseURL: 0
	},
	// 作品发布审核机制-记录
	checkLogs: {
		url: '/admin/config/logs',
		method: 'post',
		baseURL: 0
	},
	//获取用户授权签名信息
	admin_accredit_contributorInfo: {
		url: 'admin/accredit/contributorInfo',
		method: 'post',
		baseURL: 0
	},
	
	//获取父级项目信息
	admin_project_info: {
		url: '/admin/project/info',
		method: 'post',
		baseURL: 0
	},

	//摄影作品设置/取消设置推荐状态
	admin_photowork_setRecommendStatus: {
		url: 'admin/photowork/setRecommendStatus',
		method: 'post',
		baseURL: 0
	},
	//摄影作品设置/取消设置上线状态
	admin_photowork_setOnShowStatus: {
		url: 'admin/photowork/setOnShowStatus',
		method: 'post',
		baseURL: 0
	},

	api_Activity_work: {
		url: 'Api/Activity/work',
		method: 'post',
		baseURL: 0
	},

	//获取心愿列表接口
	api_usermessage_list: {
		url: 'api/usermessage/list',
		method: 'post',
		baseURL: 0
	},

	//更新反馈是否回复状态接口
	admin_feedback_fix: {
		url: 'admin/feedback/fix',
		method: 'post',
		baseURL: 0
	},
}
